/**
 * Collection Drop 2025 Landing Page Scripts
 * Handles testimonial carousel functionality
 */

(function() {
  'use strict';
  
  // Initialize carousel on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonialCarousel);
  } else {
    initTestimonialCarousel();
  }
  
  function initTestimonialCarousel() {
    const carousels = document.querySelectorAll('[data-carousel]');
    
    carousels.forEach(function(carousel) {
      const track = carousel.querySelector('.cd-testimonials__track');
      
      if (!track) return;
      
      // Enable smooth scrolling with touch/mouse drag
      let isDown = false;
      let startX;
      let scrollLeft;
      
      track.addEventListener('mousedown', function(e) {
        isDown = true;
        track.style.cursor = 'grabbing';
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
      });
      
      track.addEventListener('mouseleave', function() {
        isDown = false;
        track.style.cursor = 'grab';
      });
      
      track.addEventListener('mouseup', function() {
        isDown = false;
        track.style.cursor = 'grab';
      });
      
      track.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - track.offsetLeft;
        const walk = (x - startX) * 2;
        track.scrollLeft = scrollLeft - walk;
      });
      
      // Prevent click events when dragging
      let isDragging = false;
      
      track.addEventListener('mousedown', function() {
        isDragging = false;
      });
      
      track.addEventListener('mousemove', function() {
        isDragging = true;
      });
      
      track.addEventListener('mouseup', function(e) {
        if (isDragging) {
          e.preventDefault();
        }
      });
      
      // Set initial cursor
      track.style.cursor = 'grab';
    });
  }
  
  // Shopify theme editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('[data-carousel]')) {
        initTestimonialCarousel();
      }
    });
  }
})();
